export function topicosDoCanal(nome: string): readonly [string, string] {
  return [nome, `realtime:${nome}`];
}

export function acharCanal<T extends { topic: string }>(
  canais: readonly T[],
  nome: string,
): T | undefined {
  const [cru, prefixado] = topicosDoCanal(nome);
  return canais.find((canal) => canal.topic === cru || canal.topic === prefixado);
}

export function relogioAvanca(resposta: string | undefined): boolean {
  return resposta === 'ok';
}
